import { render, staticRenderFns } from "./reverseidcord.vue?vue&type=template&id=76b1d0a2&scoped=true&"
import script from "./reverseidcord.vue?vue&type=script&lang=js&"
export * from "./reverseidcord.vue?vue&type=script&lang=js&"
import style0 from "./reverseidcord.vue?vue&type=style&index=0&id=76b1d0a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b1d0a2",
  null
  
)

export default component.exports